export default __webpack_public_path__ + "static/media/Arch_Amazon-Elastic-Container-Kubernetes_48.6ec0d666.svg";